import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { type ApplicationConfig, ErrorHandler, APP_INITIALIZER, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, Router, withComponentInputBinding } from '@angular/router';
import * as Sentry from '@sentry/angular';

import { appRoutes } from './app.routes';
import { GtmCustomEventService } from './components/gtm-script/gtm-custom-event.service';
import { apiHeadersInterceptor } from './interceptors/api-headers.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(appRoutes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([apiHeadersInterceptor]), withInterceptorsFromDi()),
    GtmCustomEventService,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
};
